import React from 'react';
import styled from 'styled-components';
import { ArrowLeftOutlined } from '@ant-design/icons';

const GREEN = '#2f8a4c';

// The way out of a checklist or the editor. Solid and labelled: staff missed a
// bare arrow icon.
const Pill = styled.button`
  all: unset;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  gap: 0.45em;
  flex: none;
  min-height: 44px;
  padding: 0 1.1em 0 0.9em;
  border-radius: 22px;
  background: ${GREEN};
  color: #fff;
  font-weight: 700;
  font-size: 15px;
  white-space: nowrap;
  cursor: pointer;
  box-shadow: 0 3px 10px rgba(47, 138, 76, 0.28);
  transition: transform 0.08s, background 0.12s;
  .anticon {
    font-size: 16px;
  }
  &:hover {
    background: #277a42;
  }
  &:active {
    transform: scale(0.96);
  }
  &:focus-visible {
    outline: 2px solid #1c1c1c;
    outline-offset: 2px;
  }
`;

const BackButton = ({ children = 'Back', ...props }) => (
  <Pill type="button" {...props}>
    <ArrowLeftOutlined />
    {children}
  </Pill>
);

export default BackButton;
